var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation90(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 45,
    fill: "#E3F4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.2374 65.5927C42.9789 65.5927 41.9016 65.128 41.0054 64.1987C40.1092 63.2693 39.6611 62.152 39.6611 60.847C39.6611 59.5419 40.1092 58.4246 41.0054 57.4953C41.9016 56.5659 42.9789 56.1012 44.2374 56.1012C45.4959 56.1012 46.5732 56.5659 47.4694 57.4953C48.3656 58.4246 48.8137 59.5419 48.8137 60.847C48.8137 62.152 48.3656 63.2693 47.4694 64.1987C46.5732 65.128 45.4959 65.5927 44.2374 65.5927ZM44.2374 51.3554C42.9789 51.3554 41.9016 50.8907 41.0054 49.9614C40.1092 49.032 39.6611 47.9148 39.6611 46.6097V27.6266C39.6611 26.3215 40.1092 25.2043 41.0054 24.2749C41.9016 23.3455 42.9789 22.8809 44.2374 22.8809C45.4959 22.8809 46.5732 23.3455 47.4694 24.2749C48.3656 25.2043 48.8137 26.3215 48.8137 27.6266V46.6097C48.8137 47.9148 48.3656 49.032 47.4694 49.9614C46.5732 50.8907 45.4959 51.3554 44.2374 51.3554Z",
    fill: "#034CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation90);
export default __webpack_public_path__ + "static/media/exclamation_90.c4efef66610fb2546e4d24c4ee94b0d1.svg";
export { ForwardRef as ReactComponent };